import React, { useState } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const BulkActionBar = ({ selectedCount, onApproveAll, onRejectAll, onClear }) => {
  const [showRejectInput, setShowRejectInput] = useState(false);
  const [reason, setReason] = useState('');

  const handleReject = () => {
    if (!showRejectInput) { setShowRejectInput(true); return; }
    if (reason?.trim()) { onRejectAll(reason); setReason(''); setShowRejectInput(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-2.5 rounded-lg mb-3 border"
      style={{ backgroundColor: '#fffbeb', borderColor: '#f59e0b' }}>
      <span className="text-sm font-semibold" style={{ color: '#92400e' }}>
        {selectedCount} row{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={onApproveAll}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white transition hover:opacity-90"
          style={{ backgroundColor: '#16a34a' }}
        >
          <CheckCircle size={13} /> Approve Selected
        </button>
        {!showRejectInput ? (
          <button
            onClick={() => setShowRejectInput(true)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#DC143C' }}
          >
            <XCircle size={13} /> Reject Selected
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <input
              autoFocus
              value={reason}
              onChange={e => setReason(e?.target?.value)}
              placeholder="Rejection reason..."
              className="border rounded-lg px-2 py-1 text-xs outline-none"
              style={{ borderColor: '#e8ddd0', width: 180 }}
              onKeyDown={e => e?.key === 'Enter' && handleReject()}
            />
            <button
              onClick={handleReject}
              disabled={!reason?.trim()}
              className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white transition hover:opacity-90 disabled:opacity-50"
              style={{ backgroundColor: '#DC143C' }}
            >Confirm</button>
            <button onClick={() => { setShowRejectInput(false); setReason(''); }}
              className="p-1 rounded hover:bg-gray-100">
              <X size={13} style={{ color: '#6b7280' }} />
            </button>
          </div>
        )}
      </div>
      <button onClick={onClear} className="ml-auto p-1 rounded hover:bg-amber-100">
        <X size={14} style={{ color: '#92400e' }} />
      </button>
    </div>
  );
};

export default BulkActionBar;
